export enum RefTypeEnum {
  SUBENTRY = "subentry",
  FOOTNOTE = "footnote",
  LIST = "list",
  LABEL = "label",
  INTERNAL = "internal",
  // DZ = "dz",
  URL = "url",
  // HREF = "href",
  IMPORTANTURL = "importanturl",
  DZHREF = "dzhref",
  NONE = "none"
}
